import { Directive, ElementRef, Input, OnInit } from '@angular/core';

@Directive({
  selector: '[scrollbar], scrollbar-dir,  *'
})
export class ScrollbarDirective implements OnInit {
  @Input() scrollbar: string;
  @Input() allowAllScreens: boolean | string;

  hostElement: HTMLElement;

  constructor(public elementRef: ElementRef) {}

  ngOnInit() {
    // Remove the hazard overlay class from the body
    document.body.classList.remove('hazard-overlay-active');
    this.hostElement = this.elementRef.nativeElement;
    console.log(this.hostElement.tagName,'this.hostElement.tagName');
    console.log(this.allowAllScreens ,'this.allowAllScreens ');

    if (
      this.hostElement&&
      this.hostElement.tagName &&
      this.hostElement.tagName == 'ION-CONTENT' || this.hostElement.tagName == 'DIV'
    ) {
      const el = document.createElement('style');
      el.innerText = this.scrollbar || this.getCustomStyle();
      this.hostElement.shadowRoot.appendChild(el);
     }
  }

  getCustomStyle() {
    if (this.allowAllScreens === true || this.allowAllScreens === 'true') {
      return ` ::-webkit-scrollbar {
        width: 7px !important;
        padding: 10px;
      }
      ::-webkit-scrollbar-track {
        box-shadow: inset 0 0 5px #c7cbcf;
        border-radius: 5px;
      }
      ::-webkit-scrollbar-thumb {
        background: #083a81;
        border: 1px solid transparent;
        border-radius: 5px;
      }
      ::-webkit-scrollbar-thumb:hover {
        background: #083a81;
      }
      ::-webkit-scrollbar-track:hover {
        background: #083a81;
      }
      .inner-scroll {
        scrollbar-width: thin
      }
        `;
    } else {
      return `@media(pointer: fine) {
        ::-webkit-scrollbar {
          width: 7px !important;
          padding: 10px;
        }
        ::-webkit-scrollbar-track {
          box-shadow: inset 0 0 5px #c7cbcf;
          border-radius: 5px;
        }
        ::-webkit-scrollbar-thumb {
          background: #083a81;
          border: 1px solid transparent;
          border-radius: 5px;
        }
        ::-webkit-scrollbar-thumb:hover {
          background: #083a81;
        }
        ::-webkit-scrollbar-track:hover {
          background: #083a81;
        }
        .inner-scroll {
          scrollbar-width: thin
        }
      }`;
    }
  }
}
